import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

const RegisterDescription = () => {
  const navigate = useNavigate();

  const handleLeftClick = () => {
    navigate(-1);
  }
  
  return (
    <div className="award-signup-description">
      <div className="award-signup-description__box1">
        <img
          className="award-signup-description__box1__img1"
          src="/images/img_leaf_left.svg"
        />
        <div className="award-signup-description__box1__text">
          <span><strong>이 분기의 스포키즈</strong>에 선정되시면,</span>
          <span><strong>푸짐한 선물</strong>을 드립니다.</span>
        </div>
        <img
          className="award-signup-description__box1__img2"
          src="/images/img_leaf_right.svg"
        />
      </div>
      <div className="award-signup-description__box2">
        <img
          className="award-signup-description__box2__img1"
          src="/images/img_boy.svg"
        />
        <div className="award-signup-description__box2__text">
          <span>정확한 정보를 입력해주세요.</span>
        </div>
        <img
          className="award-signup-description__box2__img2"
          src="/images/img_girl.svg"
        />
      </div>
    </div>
  );
};

export default RegisterDescription;
